import axios from '@axios'
import AuthService from '@/auth/AuthService';

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
const auth = new AuthService(axios)
export default auth
